"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    content: "<p>Top banner display on all pages to advertise a special promotion such as: Save 20% this weekend!</p>",
    collapsed: false,
    exportedHTML: ''
  };
}